import React from 'react';
import { Button } from './Button';
import { PlayCircle, Zap, Crown, Send } from 'lucide-react';
export function PrivateCircleSection() {
  return <section id="private-circle" className="py-24 bg-[#060919] relative border-t border-white/5 overflow-hidden" data-id="element-267">
      {/* Mystical glow behind the section */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[600px] bg-yellow-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-268"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-269">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-270">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-271">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-272">
              Accede al Círculo Privado donde{' '}
              <span className="text-yellow-400" data-id="element-273">
                continúa tu transformación
              </span>
            </h2>

            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-274">
              He creado un espacio privado, exclusivo y en constante expansión,
              donde tendrás acceso a contenido de alto valor diseñado para
              acompañarte en cada etapa de tu crecimiento personal, energético y
              profesional.
            </p>

            <ul className="space-y-6 text-left mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-275">
              <li className="flex items-start" data-id="element-276">
                <div className="flex-shrink-0 mt-1" data-id="element-277">
                  <PlayCircle className="w-6 h-6 text-yellow-400" data-id="element-278" />
                </div>
                <p className="ml-4 text-lg text-gray-200" data-id="element-279">
                  Cursos en videos + contenido en constante actualización
                </p>
              </li>
              <li className="flex items-start" data-id="element-280">
                <div className="flex-shrink-0 mt-1" data-id="element-281">
                  <Zap className="w-6 h-6 text-yellow-400" data-id="element-282" />
                </div>
                <p className="ml-4 text-lg text-gray-200" data-id="element-283">
                  Acceso inmediato, cupos limitados
                </p>
              </li>
              <li className="flex items-start" data-id="element-284">
                <div className="flex-shrink-0 mt-1" data-id="element-285">
                  <Crown className="w-6 h-6 text-yellow-400" data-id="element-286" />
                </div>
                <p className="ml-4 text-lg text-gray-200" data-id="element-287">
                  Solo para personas comprometidas con su crecimiento
                </p>
              </li>
            </ul>

            <div className="flex flex-col items-center lg:items-start" data-id="element-288">
              <Button size="lg" href="https://t.me/Amaeliabot" className="w-full sm:w-auto px-10 py-4 text-lg mb-4" data-id="element-289">
                <Send className="w-5 h-5 mr-2" data-id="element-290" />
                ACCEDER AHORA
              </Button>
              <p className="text-sm text-gray-400 italic" data-id="element-291">
                Cursos, Recursos y Comunidad en un solo lugar.
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div className="flex-1 w-full max-w-2xl lg:max-w-none" data-id="element-292">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-[0_0_40px_rgba(212,175,55,0.15)] group" data-id="element-293">
              <div className="absolute inset-0 bg-gradient-to-t from-[#060919] via-transparent to-transparent z-10 opacity-60" data-id="element-294"></div>
              <img src="https://cdn.magicpatterns.com/uploads/sJpchk1HRGwEwz5DUqTDPk/ChatGPT_Image_2_abr_2026,_14_35_24.png" alt="Círculo Privado en Telegram" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" data-id="element-295" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}